import axios from 'axios';
import config from '../../config/main';

const getAllDiscounts = async () => {
  try {
    const res = await axios.get(`${config.apiEndpoint}/discounts`, {
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', Cache: 'no-cache' },
      withCredentials: true,
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};

const getMergedEnabledDiscounts = async () => {
  try {
    const res = await axios.get(`${config.apiEndpoint}/discounts/merged`, {
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', Cache: 'no-cache' },
      withCredentials: true,
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};

const createDiscount = async (data) => {
  try {
    const res = await axios.post(`${config.apiEndpoint}/discounts`, data, {
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', Cache: 'no-cache' },
      withCredentials: true,
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};

const toggleEnabled = async (id) => {
  try {
    const res = await axios.put(`${config.apiEndpoint}/discounts/${id}/toggle`, {}, {
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', Cache: 'no-cache' },
      withCredentials: true,
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};

const deleteDiscount = async (id) => {
  try {
    const res = await axios.delete(`${config.apiEndpoint}/discounts/${id}`, {
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', Cache: 'no-cache' },
      withCredentials: true,
    });
    return res.data;
  } catch (err) {
    throw err;
  }
};

export default {
  getAllDiscounts,
  getMergedEnabledDiscounts,
  createDiscount,
  toggleEnabled,
  deleteDiscount,
};